/* eslint-disable import/no-duplicates */

import getParameterFromURL from '../utils/scripts/getParameterFromURL';

import iconPuppy from './img/optionsImages/puppy.png';
import iconAdult from './img/optionsImages/adult.png';
import iconPoodle from './img/optionsImages/poodle.png';
import iconChick from './img/optionsImages/chick.png';
import iconBone from './img/optionsImages/bone.png';
import iconHeart from './img/optionsImages/heart.png';
import iconBall from './img/optionsImages/ball.png';
import iconOther from './img/optionsImages/other.png';
import iconSmile from './img/optionsImages/iconSmile.png';
import iconSurprised from './img/optionsImages/iconSurprised.png';
import iconPensive from './img/optionsImages/iconPensive.png';
import iconLabrador from './img/optionsImages/labrador.png';
import iconPaws from './img/optionsImages/iconPaws.png';
import iconDown from './img/optionsImages/iconDown.png';
import iconUpset from './img/optionsImages/iconUpset.png';
import iconCross from './img/optionsImages/cross.png';
import iconDontKnow from './img/optionsImages/iconDontKnow.png';
import iconDarkDog from './img/optionsImages/iconDarkDog.png';

import iconYes from './img/optionsImages/yes.png';
import iconSoso from './img/optionsImages/so-so.png';
import iconNo from './img/optionsImages/no.png';

import iconBeingHomeAloneV1 from './img/optionsImages/house.png';
import iconBeingHomeAloneV2 from './img/optionsImages/calendar.png';
import iconBeingHomeAloneV3 from './img/optionsImages/calendar2.png';
import iconBeingHomeAloneV4 from './img/optionsImages/dog.png';

import iconYesV1 from './img/optionsImages/yes.png';
import iconNoV2 from './img/optionsImages/no.png';

// import customV1ConcernV1 from './img/optionsImages/dog1.png';
// import customV1ConcernV2 from './img/optionsImages/dog2.png';
// import customV1ConcernV3 from './img/optionsImages/dog3.png';
// import customV1ConcernV4 from './img/optionsImages/dog4.png';
// import customV1ConcernV5 from './img/optionsImages/dog5.png';
// import customV1ConcernV6 from './img/optionsImages/dog6.png';

import addImgAge from './img/optionsImages/addImg_age.jpg';
import addImgJumping from './img/optionsImages/addImg_jumping.jpg';
import addImgObedience from './img/optionsImages/addImg_obedience.jpg';
import addImgPickingUp from './img/optionsImages/addImg_picking_up.jpg';
import addImgBeingForFood from './img/optionsImages/addImg_being_for_food.jpg';
import addImgPuppyOrAdult from './img/optionsImages/addImg_puppy_or_adult.jpg';
import addImgHowOld from './img/optionsImages/addImg_how_old.jpg';
import addImgBreed from './img/optionsImages/addImg_breed.jpg';
import addImgBeingHome from './img/optionsImages/addImg_being_home.jpg';
import addImgBiting from './img/optionsImages/addImg_biting.jpg';
import addImgChewing from './img/optionsImages/addImg_chewing.jpg';
import addImgHygiene from './img/optionsImages/addImg_hygiene.jpg';
import addImgPottyTraining from './img/optionsImages/addImg_potty_training.jpg';

import iconGenderGirl from './img/optionsImages/customV1girl.svg';
import iconGenderBoy from './img/optionsImages/customV1boy.svg';

import iconGenderGirlV2 from './img/optionsImages/customV2girl.svg';
import iconGenderBoyV2 from './img/optionsImages/customV2boy.svg';

import iconGenderGirlV3 from './img/optionsImages/customV2girl.png';
import iconGenderBoyV3 from './img/optionsImages/customV2boy.png';

import iconHealthV1 from './img/optionsImages/customV2IconHealthV1.svg';
import iconHealthV2 from './img/optionsImages/customV2IconHealthV2.svg';
import iconHealthV3 from './img/optionsImages/customV2IconHealthV3.svg';
import iconHealthV4 from './img/optionsImages/customV2IconHealthV4.svg';
import iconHealthV5 from './img/optionsImages/customV2IconHealthV5.svg';

import iconPottyV1 from './img/optionsImages/customV2PottyV1.svg';
import iconPottyV2 from './img/optionsImages/customV2PottyV2.svg';
import iconPottyV3 from './img/optionsImages/customV2PottyV3.svg';
import iconPottyV4 from './img/optionsImages/customV2PottyV4.svg';
import iconPottyV5 from './img/optionsImages/customV2PottyV5.svg';
import iconPottyV6 from './img/optionsImages/customV2PottyV6.svg';

import iconPottyV7 from './img/optionsImages/customV2PottyV7.svg';
import iconPottyV8 from './img/optionsImages/customV2PottyV8.svg';
import iconPottyV9 from './img/optionsImages/customV2PottyV9.svg';
import iconPottyV10 from './img/optionsImages/customV2PottyV10.svg';

import iconIssuesV1 from './img/optionsImages/customV2IssuesV1.svg';
import iconIssuesV2 from './img/optionsImages/customV2IssuesV2.svg';
import iconIssuesV3 from './img/optionsImages/customV2IssuesV3.svg';
import iconIssuesV4 from './img/optionsImages/customV2IssuesV4.svg';
import iconIssuesV5 from './img/optionsImages/customV2IssuesV5.svg';

import iconIssues2V1 from './img/optionsImages/customV2Issues2V1.svg';
import iconIssues2V2 from './img/optionsImages/customV2Issues2V2.svg';
import iconIssues2V3 from './img/optionsImages/customV2Issues2V3.svg';
import iconIssues2V4 from './img/optionsImages/customV2Issues2V4.svg';
import iconIssues2V5 from './img/optionsImages/customV2Issues2V5.svg';
import iconIssues2V6 from './img/optionsImages/customV2Issues2V6.svg';

import iconWalkingIssuesV1 from './img/optionsImages/customV2WalkingIssuesV1.svg';
import iconWalkingIssuesV2 from './img/optionsImages/customV2WalkingIssuesV2.svg';
import iconWalkingIssuesV3 from './img/optionsImages/customV2WalkingIssuesV3.svg';
import iconWalkingIssuesV4 from './img/optionsImages/customV2WalkingIssuesV4.svg';
import iconWalkingIssuesV5 from './img/optionsImages/customV2WalkingIssuesV5.svg';

import iconActivityV1 from './img/optionsImages/customV2ActivityV1.svg';
import iconActivityV2 from './img/optionsImages/customV2ActivityV2.svg';
import iconActivityV3 from './img/optionsImages/customV2ActivityV3.svg';

import iconTrainingV1 from './img/optionsImages/customV2TrainingV1.svg';
import iconTrainingV2 from './img/optionsImages/customV2TrainingV2.svg';
import iconTrainingV3 from './img/optionsImages/customV2TrainingV3.svg';

// import iconCreatingProgramV1 from './img/optionsImages/customV2CreatingProgramV1.svg';
// import iconCreatingProgramV2 from './img/optionsImages/customV2CreatingProgramV2.svg';
// import iconCreatingProgramV3 from './img/optionsImages/customV2CreatingProgramV3.svg';
// import iconCreatingProgramV4 from './img/optionsImages/customV2CreatingProgramV4.svg';

import iconCreatingProgramV5 from './img/optionsImages/customV2CreatingProgramV5.svg';
import iconCreatingProgramV6 from './img/optionsImages/customV2CreatingProgramV6.svg';
import iconCreatingProgramV7 from './img/optionsImages/customV2CreatingProgramV7.svg';
import iconCreatingProgramV8 from './img/optionsImages/customV2CreatingProgramV8.svg';

import behaviorProblemV1 from './img/optionsImages/customV4BehaviorProblemV1.jpg';
import behaviorProblemV2 from './img/optionsImages/customV4BehaviorProblemV2.jpg';
import behaviorProblemV3 from './img/optionsImages/customV4BehaviorProblemV3.jpg';
import behaviorProblemV4 from './img/optionsImages/customV4BehaviorProblemV4.jpg';

import behaviorProblemV5 from './img/optionsImages/customV4BehaviorProblemV5.jpg';
import behaviorProblemV6 from './img/optionsImages/customV4BehaviorProblemV6.jpg';
import behaviorProblemV7 from './img/optionsImages/customV4BehaviorProblemV7.jpg';
import behaviorProblemV8 from './img/optionsImages/customV4BehaviorProblemV8.jpg';

import behaviorV1 from './img/optionsImages/behaviorV1.png';
import behaviorV2 from './img/optionsImages/behaviorV2.png';
import behaviorV3 from './img/optionsImages/behaviorV3.png';
import behaviorV4 from './img/optionsImages/behaviorV4.png';
import behaviorV5 from './img/optionsImages/behaviorV5.png';
import behaviorV6 from './img/optionsImages/behaviorV6.png';
import behaviorV7 from './img/optionsImages/behaviorV7.png';

import customV2ageV1 from './img/optionsImages/customV2ageV1.jpg';
import customV2ageV2 from './img/optionsImages/customV2ageV2.jpg';
import customV2ageV3 from './img/optionsImages/customV2ageV3.jpg';
import customV2ageV4 from './img/optionsImages/customV2ageV4.jpg';
import customV2ageV5 from './img/optionsImages/customV2ageV5.jpg';
import customV2ageV6 from './img/optionsImages/customV2ageV6.jpg';

import customV2reasonV1 from './img/optionsImages/reason1.png';
import customV2reasonV2 from './img/optionsImages/reason2.png';
import customV2reasonV3 from './img/optionsImages/reason3.png';
import customV2reasonV4 from './img/optionsImages/reason4.png';
import customV2reasonV5 from './img/optionsImages/reason5.png';
import customV2reasonV6 from './img/optionsImages/reason6.png';
import customV2reasonV7 from './img/optionsImages/reason7.png';
import customV2reasonV8 from './img/optionsImages/reason8.png';

import foodV1 from './img/optionsImages/foodV1.png';
import foodV2 from './img/optionsImages/foodV2.png';
import foodV3 from './img/optionsImages/foodV3.png';
import foodV4 from './img/optionsImages/foodV4.png';

import issuesBitingV1 from './img/optionsImages/issuesBitingV1.png';
import issuesBitingV2 from './img/optionsImages/issuesBitingV2.png';

import issuesDamageV1 from './img/optionsImages/issuesDamageV1.png';
import issuesDamageV2 from './img/optionsImages/issuesDamageV2.png';

import issuesCrateV1 from './img/optionsImages/issuesCrateV1.png';
import issuesCrateV2 from './img/optionsImages/issuesCrateV2.png';

import issuesHomeV1 from './img/optionsImages/issuesHomeV1.png';
import issuesHomeV2 from './img/optionsImages/issuesHomeV2.png';
import issuesHomeV3 from './img/optionsImages/issuesHomeV3.png';
import issuesHomeV4 from './img/optionsImages/issuesHomeV4.png';

import followCommandsV1 from './img/optionsImages/followCommandsV1.png';
import followCommandsV2 from './img/optionsImages/followCommandsV2.png';
import followCommandsV3 from './img/optionsImages/followCommandsV3.png';
import followCommandsV4 from './img/optionsImages/followCommandsV4.png';

import raiseVoiceV1 from './img/optionsImages/raiseVoiceV1.png';
import raiseVoiceV2 from './img/optionsImages/raiseVoiceV2.png';
import raiseVoiceV3 from './img/optionsImages/raiseVoiceV3.png';
import raiseVoiceV4 from './img/optionsImages/raiseVoiceV4.png';

import hitDogV1 from './img/optionsImages/hitDogV1.png';
import hitDogV2 from './img/optionsImages/hitDogV2.png';

import howAttachedV1 from './img/optionsImages/howAttachedV1.png';
import howAttachedV2 from './img/optionsImages/howAttachedV2.png';
import howAttachedV3 from './img/optionsImages/howAttachedV3.png';

import ownerFeelingsV1 from './img/optionsImages/ownerFeelingsV1.svg';
import ownerFeelingsV2 from './img/optionsImages/ownerFeelingsV2.svg';
import ownerFeelingsV3 from './img/optionsImages/ownerFeelingsV3.svg';
import ownerFeelingsV4 from './img/optionsImages/ownerFeelingsV4.svg';

import ownerSleepV1 from './img/optionsImages/ownerSleepV1.svg';
import ownerSleepV2 from './img/optionsImages/ownerSleepV2.svg';
import ownerSleepV3 from './img/optionsImages/ownerSleepV3.svg';
import ownerSleepV4 from './img/optionsImages/ownerSleepV4.svg';

import ownerPuppyAffectV1 from './img/optionsImages/ownerPuppyAffectV1.svg';
import ownerPuppyAffectV2 from './img/optionsImages/ownerPuppyAffectV2.svg';
import ownerPuppyAffectV3 from './img/optionsImages/ownerPuppyAffectV3.svg';
import ownerPuppyAffectV4 from './img/optionsImages/ownerPuppyAffectV4.svg';

import ownerSupportV1 from './img/optionsImages/ownerSupportV1.svg';
import ownerSupportV2 from './img/optionsImages/ownerSupportV2.svg';
import ownerSupportV3 from './img/optionsImages/ownerSupportV3.svg';
import ownerSupportV4 from './img/optionsImages/ownerSupportV4.svg';

import ownerConcernsV1 from './img/optionsImages/ownerConcernsV1.svg';
import ownerConcernsV2 from './img/optionsImages/ownerConcernsV2.svg';
import ownerConcernsV3 from './img/optionsImages/ownerConcernsV3.svg';
import ownerConcernsV4 from './img/optionsImages/ownerConcernsV4.svg';
import ownerConcernsV5 from './img/optionsImages/ownerConcernsV5.svg';

import pottyHowLongV1 from './img/optionsImages/pottyHowLong.png';
import pottyHowLongV2 from './img/optionsImages/pottyHowLongV2.png';

import pottyWhereV1 from './img/optionsImages/pottyWhereV1.png';

import pottyHowOftenWalksV1 from './img/optionsImages/pottyHowOftenWalksV1.png';

import pottyHealthIssuesV1 from './img/optionsImages/pottyHealthIssuesV1.svg';
import pottyHealthIssuesV2 from './img/optionsImages/pottyHealthIssuesV2.svg';
import pottyHealthIssuesV3 from './img/optionsImages/pottyHealthIssuesV3.svg';
import pottyHealthIssuesV4 from './img/optionsImages/pottyHealthIssuesV4.svg';

import pottyWhereWantV1 from './img/optionsImages/pottyWhereWantV1.svg';
import pottyWhereWantV2 from './img/optionsImages/pottyWhereWantV2.svg';
import pottyWhereWantV3 from './img/optionsImages/pottyWhereWantV3.svg';

import trainingRaiseVoiceV1 from './img/optionsImages/trainingRaiseVoiceV1.svg';
import trainingRaiseVoiceV2 from './img/optionsImages/trainingRaiseVoiceV2.svg';
import trainingRaiseVoiceV3 from './img/optionsImages/trainingRaiseVoiceV3.svg';
import trainingRaiseVoiceV4 from './img/optionsImages/trainingRaiseVoiceV4.svg';

import trainingReactToPunishmentV1 from './img/optionsImages/trainingReactToPunishmentV1.svg';
import trainingReactToPunishmentV2 from './img/optionsImages/trainingReactToPunishmentV2.svg';
import trainingReactToPunishmentV3 from './img/optionsImages/trainingReactToPunishmentV3.svg';
import trainingReactToPunishmentV4 from './img/optionsImages/trainingReactToPunishmentV4.svg';

import statementIrritationV1 from './img/optionsImages/statementIrritationV1.png';
import statementIrritationV1Dark from './img/optionsImages/statementIrritationV1Dark.jpg';
import statementIgnoreCommandsV1 from './img/optionsImages/statementIgnoreCommandsV1.png';
import statementIgnoreCommandsV1Dark from './img/optionsImages/statementIgnoreCommandsV1Dark.jpg';
import statementStrongBondV1 from './img/optionsImages/statementStrongBondV1.png';
import statementStrongBondV1Dark from './img/optionsImages/statementStrongBondV1Dark.jpg';

import mainGoalV1 from './img/optionsImages/mainGoalV1.png';
import mainGoalV2 from './img/optionsImages/mainGoalV2.png';
import mainGoalV3 from './img/optionsImages/mainGoalV3.png';
import mainGoalV4 from './img/optionsImages/mainGoalV4.png';
import mainGoalV5 from './img/optionsImages/mainGoalV5.png';

import zwGirl from './img/optionsImages/zwGirl.png';
import zwBoy from './img/optionsImages/zwBoy.png';

import wo1 from './img/optionsImages/wo1.png';
import wo2 from './img/optionsImages/wo2.png';
import wo3 from './img/optionsImages/wo3.png';
import wo4 from './img/optionsImages/wo4.png';
import wo5 from './img/optionsImages/wo5.png';

import startPageAgeV1 from './img/optionsImages/startPageAgeV1.png';
import startPageAgeV2 from './img/optionsImages/startPageAgeV2.png';
import startPageAgeV3 from './img/optionsImages/startPageAgeV3.png';
import startPageAgeV4 from './img/optionsImages/startPageAgeV4.png';

import startPageAgeV2V1 from './img/optionsImages/startPageAgeV2V1.png';
import startPageAgeV2V2 from './img/optionsImages/startPageAgeV2V2.png';
import startPageAgeV2V3 from './img/optionsImages/startPageAgeV2V3.png';
import startPageAgeV2V4 from './img/optionsImages/startPageAgeV2V4.png';

import startPageAgeV3V1 from './img/optionsImages/startPageAgeV3V1.png';
import startPageAgeV3V2 from './img/optionsImages/startPageAgeV3V2.png';
import startPageAgeV3V3 from './img/optionsImages/startPageAgeV3V3.png';
import startPageAgeV3V4 from './img/optionsImages/startPageAgeV3V4.png';

import trainingTimeV1 from './img/optionsImages/trainingTimeV1.png';
import trainingTimeV2 from './img/optionsImages/trainingTimeV2.png';
import trainingTimeV3 from './img/optionsImages/trainingTimeV3.png';
import trainingTimeV4 from './img/optionsImages/trainingTimeV4.png';

import crateTrainedV1 from './img/optionsImages/crateTrainedV1.png';
import crateTrainedV2 from './img/optionsImages/crateTrainedV2.png';
import crateTrainedV3 from './img/optionsImages/crateTrainedV3.png';
import crateTrainedV4 from './img/optionsImages/crateTrainedV4.png';

import accidentsOftenV1 from './img/optionsImages/accidentsOftenV1.png';
import accidentsOftenV2 from './img/optionsImages/accidentsOftenV2.png';
import accidentsOftenV3 from './img/optionsImages/accidentsOftenV3.png';
import accidentsOftenV4 from './img/optionsImages/accidentsOftenV4.png';

import accidentsWhatDoV1 from './img/optionsImages/accidentsWhatDoV1.png';
import accidentsWhatDoV2 from './img/optionsImages/accidentsWhatDoV2.png';
import accidentsWhatDoV3 from './img/optionsImages/accidentsWhatDoV3.png';
import accidentsWhatDoV4 from './img/optionsImages/accidentsWhatDoV4.png';

import concernToiletTrainingV1 from './img/optionsImages/concernToiletTrainingV1.png';
import concernToiletTrainingV2 from './img/optionsImages/concernToiletTrainingV2.png';
import concernToiletTrainingV3 from './img/optionsImages/concernToiletTrainingV3.png';
import concernToiletTrainingV4 from './img/optionsImages/concernToiletTrainingV4.png';

import puppyChewV1 from './img/optionsImages/puppyChewV1.png';
import puppyChewV2 from './img/optionsImages/puppyChewV2.png';
import puppyChewV3 from './img/optionsImages/puppyChewV3.png';
import puppyChewV4 from './img/optionsImages/puppyChewV4.png';
import puppyChewV5 from './img/optionsImages/puppyChewV5.png';

import puppyBiteHandsV1 from './img/optionsImages/puppyBiteHandsV1.png';
import puppyBiteHandsV2 from './img/optionsImages/puppyBiteHandsV2.png';
import puppyBiteHandsV3 from './img/optionsImages/puppyBiteHandsV3.png';
import puppyBiteHandsV4 from './img/optionsImages/puppyBiteHandsV4.png';

import puppyLeaveHouseV1 from './img/optionsImages/puppyLeaveHouseV1.png';
import puppyLeaveHouseV2 from './img/optionsImages/puppyLeaveHouseV2.png';
import puppyLeaveHouseV3 from './img/optionsImages/puppyLeaveHouseV3.png';
import puppyLeaveHouseV4 from './img/optionsImages/puppyLeaveHouseV4.png';

import fixBehaviorIssuesV1 from './img/optionsImages/fixBehaviorIssuesV1.png';
import fixBehaviorIssuesV2 from './img/optionsImages/fixBehaviorIssuesV2.png';
import fixBehaviorIssuesV3 from './img/optionsImages/fixBehaviorIssuesV3.png';
import fixBehaviorIssuesV4 from './img/optionsImages/fixBehaviorIssuesV4.png';
import fixBehaviorIssuesV5 from './img/optionsImages/fixBehaviorIssuesV5.png';

const darkTheme = getParameterFromURL('darkTheme') === 'true';
const startPageAgeVar3 = getParameterFromURL('config') === 'customV48';

const optionsImages = {
  age: {
    puppy: iconPuppy,
    adult: iconAdult,
  },
  role: {
    puppy: iconPuppy,
    dog: iconAdult,
    wannabe: iconSmile,
  },
  puppy_or_adult: {
    puppy: iconPuppy,
    adult: iconAdult,
    skip: iconCross,
  },
  how_old: {
    zero: iconPuppy,
    six: iconPuppy,
    year: iconAdult,
    two_years: iconPoodle,
    five_years: iconDarkDog,
    dont_know: iconDontKnow,
    skip: iconCross,
  },
  breed: {
    dont_know: iconDontKnow,
    skip: iconCross,
  },
  dog_name: {
    skip: iconCross,
  },
  goal: {
    other: iconOther,
    teaching_puppy: iconPoodle,
    surviving_puppy: iconChick,
    socializing_puppy: iconLabrador,
    teaching_obedience: iconAdult,
    correcting_behavior: iconPuppy,
    getting_shape: iconBone,
    rasing_adopted_dog: iconHeart,
    playing_with_pooch: iconBall,
  },
  biting: {
    yes: iconSurprised,
    no: iconSmile,
    sometimes: iconPensive,
  },
  potty_training: {
    yes: iconSmile,
    no: iconSurprised,
    a_bit: iconPensive,
  },
  commands: {
    sit: iconPoodle,
    wait: iconLabrador,
    stay: iconAdult,
    place: iconPuppy,
    down: iconDown,
    leave_it: iconBone,
    come: iconPaws,
  },
  commands_puppy: {
    sit: iconPoodle,
    wait: iconLabrador,
    stay: iconAdult,
    place: iconPuppy,
    down: iconDown,
    leave_it: iconBone,
    come: iconPaws,
  },
  being_home_alone: {
    yes: iconSmile,
    no: iconSurprised,
    short_period: iconUpset,
  },
  being_home_alone_puppy: {
    yes: iconSmile,
    no: iconSurprised,
    it_varies: iconUpset,
  },
  hygiene: {
    yes: iconSmile,
    no: iconSurprised,
    only_with_some: iconUpset,
  },
  chewing: {
    yes: iconSmile,
    no: iconSurprised,
    sometimes: iconUpset,
  },
  jumping_on_people: {
    yes: iconSurprised,
    no: iconSmile,
    sometimes: iconPensive,
  },
  being_for_food: {
    yes: iconSurprised,
    no: iconSmile,
    sometimes: iconUpset,
  },
  obedience: {
    yes: iconSurprised,
    no: iconSmile,
    fifty_fifty: iconUpset,
  },
  picking_up_from_the_ground: {
    yes: iconSurprised,
    no: iconSmile,
    sometimes: iconUpset,
  },
  additional_picture: {
    age: addImgAge,
    jumping_on_people: addImgJumping,
    obedience: addImgObedience,
    picking_up_from_the_ground: addImgPickingUp,
    being_for_food: addImgBeingForFood,
    puppy_or_adult: addImgPuppyOrAdult,
    how_old: addImgHowOld,
    breed: addImgBreed,
    biting: addImgBiting,
    chewing: addImgChewing,
    being_home_alone: addImgBeingHome,
    being_home_alone_puppy: addImgBeingHome,
    hygiene: addImgHygiene,
    potty_training: addImgPottyTraining,
  },

  customV1_gender: {
    girl: iconGenderGirl,
    boy: iconGenderBoy,
  },
  customV1_age: {
  },
  customV1_breed: {
  },
  customV1_commands: {
  },
  customV1_descriptionV1: {
  },
  customV1_startPage: {
  },
  customV1_nervous: {
    yes: iconYes,
    soso: iconSoso,
    no: iconNo,
  },
  customV1_anxious: {
    yes: iconYes,
    soso: iconSoso,
    no: iconNo,
  },
  customV1_stressed: {
    yes: iconYes,
    soso: iconSoso,
    no: iconNo,
  },
  customV1_being_home_alone: {
    v1: iconBeingHomeAloneV1,
    v2: iconBeingHomeAloneV2,
    v3: iconBeingHomeAloneV3,
    v4: iconBeingHomeAloneV4,
  },
  customV1_walk: {
  },
  customV1_hygiene: {
    yes: iconYes,
    soso: iconSoso,
    no: iconNo,
  },
  customV1_concern: {
  },
  customV1_dangerous_situation: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_these_commands: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_eat_something_bad: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_this_command: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_afraid: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_descriptionV2: {
  },
  customV1_when_called: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_when_chews: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_boundaries: {
    v1: iconYesV1,
    v2: iconNoV2,
  },
  customV1_hard_training: {
    yes: iconYes,
    soso: iconSoso,
    no: iconNo,
  },
  customV1_main_goal: {
  },
  customV1_training_time: {
  },

  customV2_startPage: {},
  customV2_startPageV2: {},
  customV2_startPageV3: {},
  customV2_startPageV4: {},
  customV2_startPageV5: {},
  customV2_startPageV6: {},
  customV2_startPageV7: {},
  customV2_startPageV8: {},
  customV2_startPageV11: {},
  customV2_startPageV12: {},
  customV2_startPageV13: {},
  customV2_startPageV17: {},
  customV2_startPageV18: {},
  customV2_startPageV19: {},
  customV2_startPageV20: {},
  customV2_startPageV21: {},
  customV2_startPageV22: {},
  customV2_startPageV23: {},
  customV2_startPageV24: {},
  customV2_startPageV25: {},
  customV2_startPageV26: {},
  customV2_policyPage: {},
  customV2_policyPageV2: {},
  customV2_policyPageV3: {},
  customV2_policyPageV4: {},
  customV2_videoPolicyPage: {},
  customV2_start_page_video: {},
  customV2_start_page_video_v2: {},
  customV2_gender: {
    v1: iconGenderGirlV2,
    v2: iconGenderBoyV2,
  },
  customV2_name: {},
  customV2_age: {},
  customV2_breed: {},
  customV2_health: {
    v1: iconHealthV1,
    v2: iconHealthV2,
    v3: iconHealthV3,
    v4: iconHealthV4,
    v5: iconHealthV5,
  },
  customV2_potty: {
    v1: iconPottyV7,
    v2: iconPottyV8,
    v3: iconPottyV9,
    v4: iconPottyV10,
  },
  customV2_reason: {
    v1: customV2reasonV1,
    v2: customV2reasonV2,
    v3: customV2reasonV3,
    v4: customV2reasonV4,
    v5: customV2reasonV5,
    v6: customV2reasonV6,
    v7: customV2reasonV7,
    v8: customV2reasonV8,
  },
  customV2_date: {},
  customV2_issues: {
    v1: iconIssuesV1,
    v2: iconIssuesV2,
    v3: iconIssuesV3,
    v4: iconIssuesV4,
    v5: iconIssuesV5,
  },
  customV2_issues_2: {
    v1: iconIssues2V1,
    v2: iconIssues2V2,
    v3: iconIssues2V3,
    v4: iconIssues2V4,
    v5: iconIssues2V5,
    v6: iconIssues2V6,
  },
  customV2_walking_issues: {
    v1: iconWalkingIssuesV1,
    v2: iconWalkingIssuesV2,
    v3: iconWalkingIssuesV3,
    v4: iconWalkingIssuesV4,
    v5: iconWalkingIssuesV5,
  },
  customV2_activity: {
    v1: iconActivityV1,
    v2: iconActivityV2,
    v3: iconActivityV3,
  },
  age_group: {},
  customV2_training_time: {},
  customV2_training: {
    v1: iconTrainingV1,
    v2: iconTrainingV2,
    v3: iconTrainingV3,
  },
  customV2_command_1: {},
  customV2_command_2: {},
  customV2_command_3: {},
  customV2_command_4: {},
  customV2_info_breed: {},
  customV2_info_breed_2: {},
  customV2_info_breed_3: {},
  customV2_plan: {},
  customV2_info_predict: {},
  customV2_creating_program: {
    v1: iconCreatingProgramV5,
    v2: iconCreatingProgramV6,
    v3: iconCreatingProgramV7,
    v4: iconCreatingProgramV8,
  },

  customV3_gender: {
    v1: iconGenderGirlV2,
    v2: iconGenderBoyV2,
  },
  customV4_behavior_problem: {
    v1: behaviorProblemV1,
    v2: behaviorProblemV2,
    v3: behaviorProblemV3,
    v4: behaviorProblemV4,
  },

  customV2_age_v2: {
    v1: customV2ageV1,
    v2: customV2ageV2,
    v3: customV2ageV3,
    v4: customV2ageV4,
    v5: customV2ageV5,
    v6: customV2ageV6,
  },

  customV4_behavior_problem_v2: {
    v1: behaviorProblemV5,
    v2: behaviorProblemV6,
    v3: behaviorProblemV7,
    v4: behaviorProblemV8,
  },
  customV5_behavior_problem: {
    v1: behaviorV1,
    v2: behaviorV2,
    v3: behaviorV3,
    v4: behaviorV4,
    v5: behaviorV5,
    v6: behaviorV6,
    v7: behaviorV7,
  },
  customV2_food: {
    v1: foodV1,
    v2: foodV2,
    v3: foodV3,
    v4: foodV4,
  },
  issues_biting: {
    v1: issuesBitingV1,
    v2: issuesBitingV2,
  },
  issues_damage: {
    v1: issuesDamageV1,
    v2: issuesDamageV2,
  },
  issues_crate: {
    v1: issuesCrateV1,
    v2: issuesCrateV2,
  },
  issues_home: {
    v1: issuesHomeV1,
    v2: issuesHomeV2,
    v3: issuesHomeV3,
    v4: issuesHomeV4,
  },
  follow_commands: {
    v1: followCommandsV1,
    v2: followCommandsV2,
    v3: followCommandsV3,
    v4: followCommandsV4,
  },
  get_irritated: {
    v1: issuesHomeV2,
    v2: issuesHomeV3,
    v3: issuesHomeV4,
  },
  raise_voice: {
    v1: raiseVoiceV1,
    v2: raiseVoiceV2,
    v3: raiseVoiceV3,
    v4: raiseVoiceV4,
  },
  hit_dog: {
    v1: hitDogV1,
    v2: hitDogV2,
  },
  how_attached: {
    v1: howAttachedV1,
    v2: howAttachedV2,
    v3: howAttachedV3,
  },
  info_thank: {},
  owner_feelings: {
    v1: ownerFeelingsV1,
    v2: ownerFeelingsV2,
    v3: ownerFeelingsV3,
    v4: ownerFeelingsV4,
  },
  owner_sleep: {
    v1: ownerSleepV1,
    v2: ownerSleepV2,
    v3: ownerSleepV3,
    v4: ownerSleepV4,
  },
  owner_puppy_behavior: {
    v1: ownerFeelingsV1,
    v2: ownerFeelingsV2,
    v3: ownerFeelingsV3,
    v4: ownerFeelingsV4,
  },
  owner_puppy_managing: {
    v1: ownerFeelingsV1,
    v2: ownerFeelingsV2,
    v3: ownerFeelingsV3,
    v4: ownerFeelingsV4,
  },
  owner_puppy_affect: {
    v1: ownerPuppyAffectV1,
    v2: ownerPuppyAffectV2,
    v3: ownerPuppyAffectV3,
    v4: ownerPuppyAffectV4,
  },
  owner_support: {
    v1: ownerSupportV1,
    v2: ownerSupportV2,
    v3: ownerSupportV3,
    v4: ownerSupportV4,
  },
  owner_concerns: {
    v1: ownerConcernsV1,
    v2: ownerConcernsV2,
    v3: ownerConcernsV3,
    v4: ownerConcernsV4,
    v5: ownerConcernsV5,
  },
  info_about_owner: {},
  customV2_potty_v2: {
    v1: iconPottyV1,
    v2: iconPottyV2,
    v3: iconPottyV3,
    v4: iconPottyV5,
    v5: iconPottyV6,
    v6: iconPottyV4,
  },
  potty_how_long: {
    v1: pottyHowLongV1,
    v2: pottyHowLongV2,
  },
  potty_where: {
    v1: pottyWhereV1,
    v2: pottyWhereV1,
  },
  potty_how_often_walks: {
    v1: pottyHowOftenWalksV1,
    v2: pottyHowOftenWalksV1,
  },
  potty_health_issues: {
    v1: pottyHealthIssuesV1,
    v2: pottyHealthIssuesV2,
    v3: pottyHealthIssuesV3,
    v4: pottyHealthIssuesV4,
  },
  potty_where_want: {
    v1: pottyWhereWantV1,
    v2: pottyWhereWantV2,
    v3: pottyWhereWantV3,
    v4: pottyHealthIssuesV4,
  },
  training_raise_voice: {
    v1: trainingRaiseVoiceV1,
    v2: trainingRaiseVoiceV2,
    v3: trainingRaiseVoiceV3,
    v4: trainingRaiseVoiceV4,
  },
  training_react_to_punishment: {
    v1: trainingReactToPunishmentV1,
    v2: trainingReactToPunishmentV2,
    v3: trainingReactToPunishmentV3,
    v4: trainingReactToPunishmentV4,
  },
  statement_irritation: {
    v1: darkTheme ? statementIrritationV1Dark : statementIrritationV1,
  },
  statement_ignore_commands: {
    v1: darkTheme ? statementIgnoreCommandsV1Dark : statementIgnoreCommandsV1,
  },
  statement_strong_bond: {
    v1: darkTheme ? statementStrongBondV1Dark : statementStrongBondV1,
  },
  customV2_startPageGender: {
    v1: iconGenderGirlV3,
    v2: iconGenderBoyV3,
  },
  customV2_quote: {},
  main_goal: {
    v1: mainGoalV1,
    v2: mainGoalV2,
    v3: mainGoalV3,
    v4: mainGoalV4,
    v5: mainGoalV5,
  },
  gender_zw: {
    v1: zwGirl,
    v2: zwBoy,
  },
  zw_age: {
    v1: wo1,
    v2: wo2,
    v3: wo3,
    v4: wo4,
    v5: wo5,
  },
  start_page_age: {
    v1: startPageAgeVar3 ? startPageAgeV3V1 : startPageAgeV1,
    v2: startPageAgeVar3 ? startPageAgeV3V2 : startPageAgeV2,
    v3: startPageAgeVar3 ? startPageAgeV3V3 : startPageAgeV3,
    v4: startPageAgeVar3 ? startPageAgeV3V4 : startPageAgeV4,
  },
  start_page_age_v2: {
    v1: startPageAgeV2V1,
    v2: startPageAgeV2V2,
    v3: startPageAgeV2V3,
    v4: startPageAgeV2V4,
  },
  training_time: {
    v1: trainingTimeV1,
    v2: trainingTimeV2,
    v3: trainingTimeV3,
    v4: trainingTimeV4,
  },
  crate_trained: {
    v1: crateTrainedV1,
    v2: crateTrainedV2,
    v3: crateTrainedV3,
    v4: crateTrainedV4,
  },
  accidents_how_often: {
    v1: accidentsOftenV1,
    v2: accidentsOftenV2,
    v3: accidentsOftenV3,
    v4: accidentsOftenV4,
  },
  info_about_crate: {},
  accidents_what_do: {
    v1: accidentsWhatDoV1,
    v2: accidentsWhatDoV2,
    v3: accidentsWhatDoV3,
    v4: accidentsWhatDoV4,
  },
  concern_toilet_training: {
    v1: concernToiletTrainingV1,
    v2: concernToiletTrainingV2,
    v3: concernToiletTrainingV3,
    v4: concernToiletTrainingV4,
  },
  info_about_potty_struggles: {},
  puppy_issues_at_home: {
    v1: iconIssuesV2,
    v2: iconIssuesV3,
    v3: iconIssuesV4,
    v4: iconIssuesV5,
  },
  puppy_chew: {
    v1: puppyChewV1,
    v2: puppyChewV2,
    v3: puppyChewV3,
    v4: puppyChewV4,
    v5: puppyChewV5,
  },
  puppy_bite_hands: {
    v1: puppyBiteHandsV1,
    v2: puppyBiteHandsV2,
    v3: puppyBiteHandsV3,
    v4: puppyBiteHandsV4,
  },
  puppy_leave_house: {
    v1: puppyLeaveHouseV1,
    v2: puppyLeaveHouseV2,
    v3: puppyLeaveHouseV3,
    v4: puppyLeaveHouseV4,
  },
  fix_behavior_issues: {
    v1: fixBehaviorIssuesV1,
    v2: fixBehaviorIssuesV2,
    v3: fixBehaviorIssuesV3,
    v4: fixBehaviorIssuesV4,
    v5: fixBehaviorIssuesV5,
  },
  info_about_training: {},
  puppy_commands: {},
  first_puppy: {},
};

export default optionsImages;
